import { sigla } from '../../../shared/utils/formatters/sigla.formatter';
import { AlocacoesQuery_alocacoes_professores_professor } from '../../graphql/queries/__generated__/AlocacoesQuery';

function formatar_sigla_professor(professor?: AlocacoesQuery_alocacoes_professores_professor) {
  return professor ? sigla(professor.dsc_nome_professor) : '';
}

export { formatar_sigla_professor };
